import {
  SET_LANGUAGE,
  SET_LANGUAGE_DATA,
  RESET_LANGUAGE_DATA,
  CHECK_FOR_LANGUAGE,
  UPDATE_STATE_COMPLETELY,
} from "../actions/types";
const initialState = {
  currentLanguage: "default",
  checkLanguage: false,
  sidebar: [],
  header: [],
  commons: [
    {
      default: "teamzz",
      french: "",
    },
    {
      default: "Approved",
      french: "",
    },
    {
      default: "Dashboard",
      french: "",
    },
    {
      default: "Generating",
      french: "",
    },
    {
      default: "Status",
      french: "",
    },
    {
      default: "Remarks",
      french: "",
    },
    {
      default: "Downloading",
      french: "",
    },
    {
      default: "Loading Please Wait",
      french: "",
    },
    {
      default: "Data",
      french: "",
    },
    {
      default: "No Data Found",
      french: "",
    },
    {
      default: "Sr no",
      french: "",
    },
    {
      default: "Total Pages",
      french: "",
    },
    {
      default: "Previous",
      french: "",
    },
    {
      default: "Info",
      french: "",
    },
    {
      default: "Filters",
      french: "",
    },
    {
      default: "Next",
      french: "",
    },
    {
      default: "Drop a file or click to select",
      french: "",
    },
    {
      default: "Cancel",
      french: "",
    },
    {
      default: "Ok",
      french: "",
    },
    {
      default: "Title",
      french: "",
    },
    {
      default: "Created On",
      french: "",
    },
    {
      default: "Show Search",
      french: "",
    },
    {
      default: "Hide Search",
      french: "",
    },
    {
      default: "Show Deleted",
      french: "",
    },
    {
      default: "Hide Deleted",
      french: "",
    },
    {
      default: "Show Grid",
      french: "",
    },
    {
      default: "Hide Grid",
      french: "",
    },
    {
      default: "Download",
      french: "",
    },
    {
      default: "System Generated",
      french: "",
    },
    {
      default: "Edit",
      french: "",
    },
    {
      default: "Delete",
      french: "",
    },
    {
      default: "Clear",
      french: "",
    },
    {
      default: "Search",
      french: "",
    },
    {
      default: "FILTER",
      french: "",
    },
    {
      default: "AND",
      french: "",
    },
    {
      default: "OR",
      french: "",
    },
    {
      default: "Loading",
      french: "",
    },
  ],
  results: [
    {
      default: "View all damages",
      french: "",
    },
    {
      default: "Are you sure you want to restore this report?",
      french: "",
    },
    {
      default: "Are you sure you want to delete this report?",
      french: "",
    },
    {
      default: "Summary",
      french: "",
    },
    {
      default: "Assets",
      french: "",
    },
    {
      default: "Damages",
      french: "",
    },
    {
      default: "Reports",
      french: "",
    },
    {
      default: "Site",
      french: "",
    },
    {
      default: "Total Assets",
      french: "",
    },
    {
      default: "Heath Status",
      french: "",
    },
    {
      default: "Critical Assets",
      french: "",
    },
    {
      default: "Total Damages",
      french: "",
    },
    {
      default: "Severe Damages",
      french: "",
    },
    {
      default: "Portfolio Health",
      french: "",
    },
    {
      default: "Damage Distribution by Type",
      french: "",
    },
    {
      default: "Damage Distribution by Severity",
      french: "",
    },
    {
      default: "Selected Asset",
      french: "",
    },
    {
      default: "Manufacturer",
      french: "",
    },
    {
      default: "Model",
      french: "",
    },
    {
      default: "Asset Health",
      french: "",
    },
    {
      default: "Click to view bladewise damage count",
      french: "",
    },
    {
      default: "Click to view bladewise asset health",
      french: "",
    },
    {
      default: "Critical Damages",
      french: "",
    },
    {
      default: "Blade wise damage count",
      french: "",
    },
    {
      default: "Blade wise health status",
      french: "",
    },
    {
      default: "Number of Damages",
      french: "",
    },
    {
      default: "Damage Type",
      french: "",
    },
    {
      default: "Severity",
      french: "",
    },
    {
      default: "Blade",
      french: "",
    },
    {
      default: "Side",
      french: "",
    },
    {
      default: "Location",
      french: "",
    },
    {
      default: "Size",
      french: "",
    },
    {
      default: "Count of Damages along blade",
      french: "",
    },
    {
      default: "Damage Name",
      french: "",
    },
    {
      default: "Asset Name",
      french: "",
    },
    {
      default: "Asset Components",
      french: "",
    },
    {
      default: "Generate Reports",
      french: "",
    },
    {
      default: "Upload Report",
      french: "",
    },
    {
      default: "Change Asset",
      french: "",
    },
    {
      default: "Line Length (KMs)",
      french: "",
    },
    {
      default: "Line length by Circuit",
      french: "",
    },
    {
      default: "Structure distribution by Circuit",
      french: "",
    },
    {
      default: "Damage Distribution by Component",
      french: "",
    },
    {
      default: "Damage Distribution by Damage Types",
      french: "",
    },
    {
      default: "Circuit",
      french: "",
    },
    {
      default: "Count of Structures",
      french: "",
    },
    {
      default: "Are you sure you to stop Report Generation ?",
      french: "",
    },
    {
      default: "OH Lines (KMs)",
      french: "",
    },
    {
      default: "Voltage (KV)",
      french: "",
    },
    {
      default: "Span Criticality Distribution",
      french: "",
    },
    {
      default: "Vegetation Coverage (KMs)",
      french: "",
    },
    {
      default: "Vegetation Area (sq.m)",
      french: "",
    },
    {
      default: "Vegetation Area (sq.m)",
      french: "",
    },
    {
      default: "Vegetation Area vs Health",
      french: "",
    },
    {
      default: "Total Area",
      french: "",
    },
    {
      default: "Critical Unhealthy Area",
      french: "",
    },
    {
      default: "Minimum Distance of Vegetation",
      french: "",
    },
    {
      default: "Span Length Encroachment",
      french: "",
    },
    {
      default: "Horizontal",
      french: "",
    },
    {
      default: "Vertical",
      french: "",
    },
    {
      default: "Distance (m)",
      french: "",
    },
    {
      default: "Spans",
      french: "",
    },
    {
      default: "Critical Spans",
      french: "",
    },
    {
      default: "Count of spans",
      french: "",
    },
    {
      default: "% of span under encroachment",
      french: "",
    },
    {
      default: "With Vegetation",
      french: "",
    },
    {
      default: "Without Vegetation",
      french: "",
    },
    {
      default: "Span ID",
      french: "",
    },
    {
      default: "Span Length (m)",
      french: "",
    },
    {
      default: "Wire Height",
      french: "",
    },
    {
      default: "Criticality",
      french: "",
    },
    {
      default: "Priority",
      french: "",
    },
    {
      default: "Total Area of Vegetation (sq.m)",
      french: "",
    },
    {
      default: "Encroachment Risks Zones",
      french: "",
    },
    {
      default: "within ROI",
      french: "",
    },
    {
      default: "Line Under Encroachment (m)",
      french: "",
    },
    {
      default: "Vegetation Encroachment Area (sq.m)",
      french: "",
    },
    {
      default: "Min. Horizontal Distance (m)",
      french: "",
    },
    {
      default: "Min. Vertical Distance (m)",
      french: "",
    },
    {
      default: "Avg. Horizontal Distance (m)",
      french: "",
    },
    {
      default: "Avg. Vertical Distance (m)",
      french: "",
    },
    {
      default: "Avg. Vegetation Health (%)",
      french: "",
    },
    {
      default: "Map",
      french: "",
    },
    {
      default: "Fields",
      french: "",
    },
    {
      default: "Select Fields",
      french: "",
    },
    {
      default: "Risk Zones Definitions",
      french: "",
    },
    {
      default: "Risk Zones",
      french: "",
    },
    {
      default: "Immediate Risk",
      french: "",
    },
    {
      default:
        "Tall vegetation in close proximity to the span requiring urgent attention.",
      french: "",
    },
    {
      default: "Grow-in Risk",
      french: "",
    },
    {
      default:
        "Vegetation directly under or near the span with future risk of encroachment.",
      french: "",
    },
    {
      default: "Fall-in Risk",
      french: "",
    },
    {
      default:
        "Tall vegetation near the span with a risk of falling onto the line.",
      french: "",
    },
    {
      default: "Under Observation",
      french: "",
    },
    {
      default: "Small vegetation with no short or mid-term risk to the span.",
      french: "",
    },
    {
      default: "No Risk",
      french: "",
    },
    {
      default:
        "Vegetation far away from the line (>7m) and with no fall-in risk.",
      french: "",
    },
    {
      default: "High",
      french: "",
    },
    {
      default:
        "Definition: Spans with severe encroachment needing urgent action",
      french: "",
    },
    {
      default: "Identification: Any vegetation near span with 'Immediate Risk'",
      french: "",
    },
    {
      default: "Medium",
      french: "",
    },
    {
      default: "Definition: Spans with risk of future encroachment",
      french: "",
    },
    {
      default:
        "Identification: No 'Immediate Risk' but future encroachment risk present (grow-in or fall-in)",
      french: "",
    },
    {
      default: "Low",
      french: "",
    },
    {
      default: "Definition: Spans with limited/ no risk of encroachment",
      french: "",
    },
    {
      default: "Identification: No 'Immediate Risk' and no known future risk",
      french: "",
    },
    {
      default: "Layers",
      french: "",
    },
    {
      default: "Base Layers",
      french: "",
    },
    {
      default: "Asset Layers",
      french: "",
    },
    {
      default: "Risk Zones",
      french: "",
    },
    {
      default: "Annotation Layers",
      french: "",
    },
    {
      default: "Span",
      french: "",
    },
    {
      default: "Pole",
      french: "",
    },
    {
      default: "Legends",
      french: "",
    },
    {
      default: "Satellite",
      french: "",
    },
    {
      default: "Vegetation within region of interest",
      french: "",
    },
  ],
};

function companyReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CHECK_FOR_LANGUAGE:
      return {
        ...state,
        checkLanguage: payload,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        currentLanguage: payload,
      };
    case RESET_LANGUAGE_DATA:
      return {
        ...initialState,
        currentLanguage: state.currentLanguage,
      };
    case SET_LANGUAGE_DATA:
      return {
        ...state,
        [payload.key]: payload.data,
      };
    case UPDATE_STATE_COMPLETELY:
      return {
        ...payload,
      };
    default:
      return state;
  }
}

export default companyReducer;
